import { CreateSalesPortalOrderGuideCollectionMutation } from '@/types';
import { OrderGuide } from '@/experiences/sales-portal/domain/order-guides/blocs/types';

type CreatedCollection = NonNullable<
  CreateSalesPortalOrderGuideCollectionMutation['createOrderGuideCollection']['order_guide_restaurant_collection']
>;

/**
 * Builds the empty guide for a newly created collection from the create
 * mutation's response, so the screen can render it without a round trip to
 * load items since a new guide has none. New guides are always editable, so every
 * partition is included.
 */
export const toCreatedOrderGuide = (
  collection: CreatedCollection,
): OrderGuide => ({
  collectionUUID: collection.uuid,
  isDefault: collection.is_default,
  name: collection.name ?? null,
  partitions: collection.order_guide_restaurant_partitions.map((partition) => ({
    isDefault: partition.is_default,
    itemGroups: [],
    name: partition.name ?? null,
    partitionUUID: partition.uuid,
  })),
});
